module.exports = __webpack_public_path__ + "img/ic_happytable_no3.1c60889d.png";